"use strict";

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(exports, "__esModule", { value: true });
var gatsby_link_5 = require("gatsby-link");
var React = require("react");
var HeaderMenu_2 = require("../components/HeaderMenu/HeaderMenu");
var SidebarMenu_1 = require("../components/SidebarMenu/SidebarMenu");
var semantic_ui_react_10 = require("semantic-ui-react");
require("../css/styles.css");
require("../css/responsive.css");
require("../css/semantic.min.css");
require("prismjs/themes/prism-okaidia.css");
exports.menuItems = [{ name: "Home", path: "/", exact: true, icon: "home", inverted: true }, { name: "Steps", path: "/steps/", exact: false, icon: "book" }, { name: "Try", path: "/try/", exact: false, icon: "code" }];

var DefaultLayout = function (_React$PureComponent) {
    (0, _inherits3.default)(DefaultLayout, _React$PureComponent);

    function DefaultLayout() {
        (0, _classCallCheck3.default)(this, DefaultLayout);
        return (0, _possibleConstructorReturn3.default)(this, (DefaultLayout.__proto__ || Object.getPrototypeOf(DefaultLayout)).apply(this, arguments));
    }

    (0, _createClass3.default)(DefaultLayout, [{
        key: "render",
        value: function render() {
            var pathname = this.props.location.pathname;

            var isHome = pathname === "/" || pathname === "/gradus-reason" || pathname === "/gradus-reason/";
            return React.createElement(semantic_ui_react_10.Sidebar.Pushable, { as: semantic_ui_react_10.Segment }, React.createElement(SidebarMenu_1.default, { Link: gatsby_link_5.default, pathname: pathname, items: exports.menuItems, visible: false }), React.createElement(semantic_ui_react_10.Sidebar.Pusher, { style: { minHeight: "100vh" } }, isHome ? null : React.createElement(HeaderMenu_2.default, { Link: gatsby_link_5.default, pathname: pathname, items: exports.menuItems }), React.createElement("div", { style: { paddingBottom: 60 } }, this.props.children()), React.createElement(semantic_ui_react_10.Segment, { inverted: true, vertical: true, style: { position: "absolute", bottom: 0, width: "100%" } }, React.createElement(semantic_ui_react_10.Container, { textAlign: "center" }, React.createElement("a", { href: "https://github.com/codekiln/gradus-reason", target: "_blank" }, React.createElement(semantic_ui_react_10.Icon, { circular: true, link: true, color: "pink", size: "big", name: "github" }))))));
        }
    }]);
    return DefaultLayout;
}(React.PureComponent);

exports.default = DefaultLayout;


// WEBPACK FOOTER //
// ./~/babel-loader/lib?{"presets":["babel-preset-env"],"plugins":["/home/travis/build/codekiln/gradus-reason/~/gatsby/dist/utils/babel-plugin-extract-graphql.js"]}!./~/ts-loader!./src/layouts/index.tsx